import styled from "styled-components";

export const LayoutStyle = styled.div`
    height: 100vh;
    display: flex;
    flex-direction: column;
`;
